import apis from '../apis/apis'

const heDaoTaoProcessor = {}
const controllerName = 'HeDaoTao'

heDaoTaoProcessor.getAll = async () => {
  const rs = await apis[controllerName].GetAll({})
  return rs.isSuccess ? rs.data.values : []
}
heDaoTaoProcessor.upsert = async (data) => {
  let rs
  if (data.id) {
    rs = await apis[controllerName].Update({ method: 'post', responseType: 'text', data })
  } else {
    rs = await apis[controllerName].Create({ method: 'post', responseType: 'text', data })
  }
  return rs
}

heDaoTaoProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

export default heDaoTaoProcessor
